exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notice{margin-top:200px}.notice .content-title{font-size:2rem !important}.notice .content-section{text-align:center}.notice .MuiButtonBase-root{color:#30b81e !important;background:#fff 0% 0% no-repeat padding-box;box-shadow:6px 6px 12px rgba(59,61,64,.3019607843);border:1px solid #e5e5e5;border-radius:6px;opacity:.9}.notice .button-card{background:#fff 0% 0% no-repeat padding-box;box-shadow:6px 6px 12px rgba(59,61,64,.3019607843);border:1px solid #e5e5e5;border-radius:6px;opacity:.9;margin-left:10 !important}.notice .MuiButton-label{font-size:20px;letter-spacing:-0.1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Helpers/Errors/Templates/NoIeSupport.scss
// module id = 7965
// module chunks = 13